import "./BasicInfo.css";
import { useEffect, useState } from "react";
import { RestaurantService } from "deliziora-client-module/client-web";
import { Flex, Image, Typography, message } from "antd";
import UploadImages from "../UploadImages/Upload";
import UploadImagesButton from "../UploadImagesButton/UploadImagesButton";
import { isMobile } from "react-device-detect";
const BasicInfo = () => {
  const restaurant = JSON.parse(localStorage.getItem("userData"));
  const [image, setImage] = useState(restaurant.img);
  const [images, setImages] = useState("");
  const [fileList, setFileList] = useState([]);
  const handleDataReceivedImages = (values) => {
    console.log(values);
    if (values.length > 0) {
      RestaurantService.updateRestaurantById({
        id_restaurant: restaurant._id.$oid,
        name: restaurant.name,
        address: restaurant.address,
        latitude: restaurant.latitude,
        especialty: restaurant.especialty,
        complete_menu: restaurant.complete_menu,
        email: restaurant.email,
        opening_hours: restaurant.opening_hours,
        longitude: restaurant.longitude,
        contact: restaurant.contact,
        description: restaurant.description,
        img: values,
        categories: restaurant.categories,
        characteristics: restaurant.characteristics,
        updated_at: "",
      })
        .then((res) => {
          RestaurantService.returnRestaurantById(restaurant._id.$oid)
            .then((res) => {
              console.log(res.data);
              setImage(res.data.img);
              message.success("Imagem mudada com sucesso");
              localStorage.setItem("userData", JSON.stringify(res.data))
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    RestaurantService.returnRestaurantById(restaurant._id.$oid)
      .then((res) => {
        console.log(res.data);
        setImage(res.data.img);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  return (
    <Flex vertical align="center" justify="center" style={{
      borderRadius: "10px",
      width: isMobile ? "90%" : "95%",
      height: isMobile? "" : "98%",
      margin: "auto",
      padding: "1rem",
    }}>
      <Typography.Title level={4}>Informações básicas</Typography.Title>
      <Flex
        vertical={isMobile === true ? "true" : "false"}
        align="center"
        gap={isMobile ? 10 : 55}
        style={{ width: isMobile ? "50%" : "100%" , height: "100%"}}

      >
        <img src={image} alt={image} style={
          {
            borderRadius: "2%",
            width: isMobile ? "90vw" : "100%",
            height: isMobile ? "300px" : "70%",
            objectFit: "cover",
          }
        } />
        <UploadImagesButton
          onDataReceived={handleDataReceivedImages}
          setImagesList={setImages}
          fileList={fileList}
          setFileList={setFileList}
        />
      </Flex>
    </Flex>
  );
};

export default BasicInfo;
